// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federtypen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federtypenDE: PageEntry = {
  id: "post.federtypen",
  locale: "de",
  slug: "federtypen",
  seo: {
    title: "Glossar: Federtypen einfach erklärt | Dietz GmbH",
    description: "Federtypen beschreiben die Vielfalt der verfügbaren Federformen und -konstruktionen. Es gibt verschiedene Federtypen, darunter Zugfedern, Druckfedern, Torsionsfedern und Blattfeder",
  },
  type: "post",
  h1: "Glossar: Federtypen einfach erklärt",
  intro: "Federtypen beschreiben die Vielfalt der verfügbaren Federformen und -konstruktionen. Es gibt verschiedene Federtypen, darunter Zugfedern, Druckfedern, Torsionsfedern und Blattfedern. Jeder Federtyp hat spezifische Anwendungen und Eigenschaften, die ihn für bestimmte Aufgaben geeignet machen. Das Verständnis der verschiedenen Federtypen ist entscheidend für Ingenieure und Konstrukteure, um die richtige Feder für eine spezifische Anwendung auszuwählen und zu konstruieren. Die Auswahl des geeigneten Federtyps trägt zur effizienten und zuverlässigen Funktion von Feder-Systemen bei.",
  blocks: [

  ],
};
